import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "showcase-hero ion-padding" }
const _hoisted_2 = { class: "showcase-header-row" }
const _hoisted_3 = { class: "showcase-brand" }
const _hoisted_4 = {
  key: 0,
  class: "ion-padding ion-text-center showcase-error"
}
const _hoisted_5 = {
  key: 1,
  class: "showcase-loading-wrap"
}
const _hoisted_6 = { class: "showcase-section showcase-section--first" }
const _hoisted_7 = {
  key: 0,
  class: "showcase-empty"
}
const _hoisted_8 = {
  key: 1,
  class: "showcase-scroll-wrap"
}
const _hoisted_9 = { class: "showcase-scroll" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "showcase-event-title" }
const _hoisted_13 = { class: "showcase-event-meta" }
const _hoisted_14 = { class: "showcase-event-loc" }
const _hoisted_15 = { class: "showcase-event-badges" }
const _hoisted_16 = {
  key: 0,
  class: "showcase-badge showcase-badge--paid"
}
const _hoisted_17 = {
  key: 1,
  class: "showcase-badge showcase-badge--soldout"
}
const _hoisted_18 = {
  key: 2,
  class: "showcase-badge showcase-badge--registered"
}
const _hoisted_19 = { class: "showcase-section" }
const _hoisted_20 = {
  key: 0,
  class: "showcase-empty"
}
const _hoisted_21 = {
  key: 1,
  class: "showcase-scroll-wrap"
}
const _hoisted_22 = { class: "showcase-scroll" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "showcase-program-cover" }
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { class: "showcase-tile-title" }
const _hoisted_27 = { class: "showcase-release-count" }
const _hoisted_28 = { class: "showcase-section showcase-section--last" }
const _hoisted_29 = {
  key: 0,
  class: "showcase-empty"
}
const _hoisted_30 = {
  key: 1,
  class: "showcase-scroll-wrap"
}
const _hoisted_31 = { class: "showcase-scroll" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  class: "showcase-tile-icon",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "showcase-tile-title" }
const _hoisted_35 = {
  key: 0,
  class: "showcase-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background showcase-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[4] || (_cache[4] = _createElementVNode("div", {
              class: "showcase-hero-glow",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ion_button, {
                  class: "showcase-menu-btn",
                  fill: "clear",
                  size: "small",
                  "aria-label": "Открыть меню",
                  onClick: _ctx.openMainMenu
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.menuOutline }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "showcase-title-wrap" }, [
                  _createElementVNode("h1", { class: "showcase-title" }, "Национальная Лига Тренеров"),
                  _createElementVNode("p", { class: "showcase-subtitle" }, "События · Релизы · Тренинги")
                ], -1))
              ]),
              (!_ctx.authenticated)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    class: "showcase-login-btn showcase-accent-btn",
                    fill: "solid",
                    size: "small",
                    onClick: _ctx.goLogin
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode(" Вход ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    class: "showcase-login-btn showcase-accent-btn",
                    fill: "solid",
                    size: "small",
                    "aria-label": "Перейти к разделу «Сегодня»",
                    onClick: _ctx.goToday
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" Сегодня ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
            ])
          ]),
          (_ctx.loadError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.loadError), 1))
            : (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ion_spinner, {
                    name: "crescent",
                    color: "light"
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "showcase-loading-text" }, "Загрузка витрины…", -1))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("section", _hoisted_6, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "showcase-section-head" }, [
                      _createElementVNode("span", {
                        class: "showcase-section-accent",
                        "aria-hidden": "true"
                      }),
                      _createElementVNode("h2", { class: "showcase-section-title" }, "События")
                    ], -1)),
                    (_ctx.events.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Нет предстоящих событий"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (ev) => {
                              return (_openBlock(), _createElementBlock("article", {
                                key: 'ev-' + ev.id,
                                class: "showcase-event-card",
                                onClick: ($event: any) => (_ctx.onEventCardClick(ev))
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["showcase-event-image-wrap", { 'showcase-event-image-wrap--no-logo': !ev.logoPath }])
                                }, [
                                  (ev.logoPath)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.eventsService.logoUrl(ev.logoPath, 480),
                                        alt: ev.title || '',
                                        class: "showcase-event-img"
                                      }, null, 8, _hoisted_11))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["showcase-event-overlay", { 'showcase-event-overlay--no-logo': !ev.logoPath }])
                                  }, [
                                    _createElementVNode("h3", _hoisted_12, _toDisplayString(ev.title), 1),
                                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.formatEventDate(ev.startAt)), 1),
                                    _createElementVNode("p", _hoisted_14, _toDisplayString(ev.location || 'Место уточняется'), 1),
                                    _createElementVNode("div", _hoisted_15, [
                                      (_ctx.isEventPaid(ev))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Платное"))
                                        : _createCommentVNode("", true),
                                      (_ctx.isSoldOut(ev))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Sold out"))
                                        : _createCommentVNode("", true),
                                      (_ctx.isRegistered(ev))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Записан"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 2)
                                ], 2),
                                (_ctx.isEventPaid(ev) && !_ctx.isSoldOut(ev) && !_ctx.isRegistered(ev))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "showcase-event-actions",
                                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      _createVNode(_component_ion_button, {
                                        expand: "block",
                                        class: "showcase-buy-btn showcase-accent-btn",
                                        fill: "solid",
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.onPaidEventAction(ev))
                                      }, {
                                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                          _createTextVNode(" Оформить участие ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_10))
                            }), 128))
                          ])
                        ]))
                  ]),
                  _createElementVNode("section", _hoisted_19, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "showcase-section-head" }, [
                      _createElementVNode("span", {
                        class: "showcase-section-accent showcase-section-accent--orange",
                        "aria-hidden": "true"
                      }),
                      _createElementVNode("h2", { class: "showcase-section-title" }, "Релизы от Лиги")
                    ], -1)),
                    (_ctx.programs.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, "Пока нет программ"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (p) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: 'prog-' + p.id,
                                type: "button",
                                class: "showcase-tile showcase-tile--program",
                                onClick: ($event: any) => (_ctx.onProgramClick(p))
                              }, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("img", {
                                    src: _ctx.programCoverUrl(p.shortName),
                                    alt: p.programName || '',
                                    class: "showcase-cover-img"
                                  }, null, 8, _hoisted_25)
                                ]),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(p.programName), 1),
                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.releaseCount(p)) + " " + _toDisplayString(_ctx.releaseCountLabel(_ctx.releaseCount(p))), 1)
                              ], 8, _hoisted_23))
                            }), 128))
                          ])
                        ]))
                  ]),
                  _createElementVNode("section", _hoisted_28, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "showcase-section-head" }, [
                      _createElementVNode("span", {
                        class: "showcase-section-accent",
                        "aria-hidden": "true"
                      }),
                      _createElementVNode("h2", { class: "showcase-section-title" }, "Тренинги")
                    ], -1)),
                    (_ctx.educationSectionsVisible.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, "Пока нет разделов"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSectionsVisible, (sec) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: 'edu-' + sec.folderKey,
                                type: "button",
                                class: "showcase-tile showcase-tile--edu",
                                onClick: ($event: any) => (_ctx.onEducationSectionClick(sec))
                              }, [
                                _createElementVNode("span", _hoisted_33, [
                                  _createVNode(_component_ion_icon, { icon: _ctx.schoolOutline }, null, 8, ["icon"])
                                ]),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(sec.name), 1)
                              ], 8, _hoisted_32))
                            }), 128))
                          ])
                        ]))
                  ])
                ], 64)),
          _createVNode(_component_ion_modal, {
            class: "showcase-program-modal",
            "is-open": _ctx.programModalOpen,
            onDidDismiss: _ctx.closeProgramModal
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, { class: "ion-no-border showcase-modal-header" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.programModalTitle), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, { onClick: _ctx.closeProgramModal }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("Закрыть", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, { class: "main-background ion-padding" }, {
                default: _withCtx(() => [
                  (_ctx.programModalReleases.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_35, "Нет релизов"))
                    : (_openBlock(), _createBlock(_component_ion_list, {
                        key: 1,
                        lines: "full",
                        class: "showcase-modal-list"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programModalReleases, (rel) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              key: 'modal-rel-' + rel.id,
                              button: "",
                              detail: "",
                              class: "showcase-modal-item",
                              onClick: ($event: any) => (_ctx.onModalReleaseClick(rel))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h3", null, _toDisplayString(rel.releaseName), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open", "onDidDismiss"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}